import mixpanel, { Dict } from "mixpanel-browser";

let initialized = false;
let identifyInitialized = false;

export function initMixpanel() {
  if (initialized) return;

  let REACT_APP_EVENTS_TOKEN = undefined;
  if (process.env.REACT_APP_EVENTS_TOKEN) {
    REACT_APP_EVENTS_TOKEN = process.env.REACT_APP_EVENTS_TOKEN;
  }

  if (REACT_APP_EVENTS_TOKEN != undefined) {
    mixpanel.init(REACT_APP_EVENTS_TOKEN, {
      debug: true,
    });
  }

  initialized = true;
}

export function mixpanelTrack(event_name: string, properties?: Dict) {
  let REACT_APP_EVENTS_TOKEN = undefined;
  if (process.env.REACT_APP_EVENTS_TOKEN) {
    REACT_APP_EVENTS_TOKEN = process.env.REACT_APP_EVENTS_TOKEN;
  }
  if (process.env.REACT_APP_EVENTS_TOKEN != undefined) {
    mixpanel.track(event_name, properties);
  }
}

export function identifyMixpanelUser(data: any) {
  if (!initialized) {
    return;
  }
  if (identifyInitialized) {
    return;
  }
  try {
    if (data && data?.colendiId != undefined && data?.colendiId != null) {
      mixpanel.identify(data.colendiId);
      identifyInitialized = true;

      if (data?.firstName) {
        mixpanel.people.set({
          first_name: data.firstName,
        });
      }
      if (data?.lastName) {
        mixpanel.people.set({
          last_name: data.lastName,
        });
      }
      if (data?.phoneNumber) {
        mixpanel.people.set({
          phone_number: data.phoneNumber,
        });
      }
    }
  } catch (err) {
  }
}
